import styled from 'styled-components';
import {Card, css} from '@mui/material';

const SelectCardList = styled(Card)<{selected?: boolean; cursor?: string}>`
	border: 1px solid transparent;
	display: flex;
	padding: 24px;
	cursor: ${({cursor}) => cursor || 'pointer'};

	${({selected, theme}) =>
		selected &&
		css`
			border: 1px solid ${theme.palette.success.main};
		`}
`;

const StyledCard = styled(Card)`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export {SelectCardList, StyledCard};
